<template>
  <div class="position-relative">
    <BaseTopLine> </BaseTopLine>
    <div class=" d-flex gap-5 align-items-center justify-content-between border-top border-top-white position-relative"
      style="background-color: #1d1e2c">
      <div class="vue-tabs">
        <div class="nav-tabs-navigation">
          <div class="nav-tabs-wrapper">
            <ul role="tablist" class="nav nav-tabs px-0">
              <li class="tab" @click="handleTabChange('Активные')" :class="{
                active: activateTab == 'Активные',
              }">
                <a href="#" role="tab" class="tabs__link px-30" :class="{
                  active_tab: activateTab == 'Активные',
                }"><span class="title title_center fsc-14 fw-normal">
                    Активные
                  </span></a>
              </li>
              <li class="tab" @click="handleTabChange('Архивные')" :class="{
                active: activateTab == 'Архивные',
              }">
                <a href="#" :class="{
                  active_tab: activateTab == 'Архивные',
                }" class="tabs__link px-30"><span class="title title_center fsc-14 fw-normal">
                    Архивные
                  </span></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="end-15 position-absolute d-flex d-flex align-items-center gap-5" v-if="activateTab == 'Активные'"
        style="">

        <div class="fsc-11 text-white">Оповещать о новых заявках</div>
        <div class="d-flex align-items-center gap-10">
          <BaseCheckboxV2 placeholder="" class="gap-5" boxClass="bg-white" input-name="sound"
            v-model="userPageSetting.sound" @oncheckeds="updateUserSettingCheckboxValue">
            <span class="text-white">Звук</span>
          </BaseCheckboxV2>
          <BaseCheckboxV2 placeholder="" class="gap-5" boxClass="bg-white" input-name="sms"
            v-model="userPageSetting.sms" @oncheckeds="updateUserSettingCheckboxValue">
            <span class="text-white">SMS</span>
          </BaseCheckboxV2>
          <BaseCheckboxV2 placeholder="" class="gap-5" boxClass="bg-white" input-name="email"
            v-model="userPageSetting.email" @oncheckeds="updateUserSettingCheckboxValue">
            <span class="text-white">E-mail</span>
          </BaseCheckboxV2>
        </div>
      </div>
    </div>
    <div>
      <div class="bg-system-primary py-10 px-15 border-top d-flex gap-10 align-items-center" ref="topFilter">
        <div class="d-flex gap-10">
          <div class="d-flex gap-5   align-items-center">
            <span class="text-white fsc-11">№ заявки</span>
            <div class="d-flex gap-5 flex-grow-1">
              <BaseInputNew placeholder="" style="width: 173px" @input="fillFilter"
                inputClass="bg-transparent text-white" :additionalParams="{}" inputName="b2b_orders__id" value=""
                nameSign="" />
            </div>
          </div>
          <div class="d-flex gap-5   align-items-center">
            <span class="text-white fsc-11">Дата заявки</span>
            <div class="d-flex gap-5 flex-grow-1 align-items-center">
              <BaseDatePicker v-model="filterTimes.ordersCreateStart" type="date" placeholder="c"
                class="idiots-class-for-input-date top-filter-input-date" lang="ru" style="width: 107px"
                value-type="format" :format="`${userSetting.company__tempalte_date}`"
                @change="(date) => setCreatedAtFilter('from', date)">
              </BaseDatePicker>
              <div class="text-white fsc-11">-</div>
              <BaseDatePicker v-model="filterTimes.ordersCreateEnd" type="date" placeholder="по"
                class="idiots-class-for-input-date top-filter-input-date" lang="ru" style="width: 107px"
                value-type="format" :format="`${userSetting.company__tempalte_date}`"
                @change="(date) => setCreatedAtFilter('to', date)">
              </BaseDatePicker>
            </div>
          </div>
          <div class="d-flex gap-5    align-items-center">
            <span class="text-white fsc-11">ID покупателя</span>
            <div class="d-flex gap-5 flex-grow-1">
              <BaseInputNew placeholder="" style="width: 173px" @input="fillFilter"
                inputClass="bg-transparent text-white" :additionalParams="{}" inputName="b2b_orders__buyer_company_id"
                value="" nameSign="" />
            </div>
          </div>
          <div class="d-flex gap-5    align-items-center">
            <span class="text-white fsc-11">ID поставщика</span>
            <div class="d-flex gap-5 flex-grow-1">
              <BaseInputNew placeholder="" style="width: 173px" @input="fillFilter"
                inputClass="bg-transparent text-white" :additionalParams="{}"
                inputName="b2b_orders__supplier_company_id" value="" nameSign="" />
            </div>
          </div>
        </div>
        <div class="d-flex  align-items-center gap-10">
          <div class="btn btn-sm btn-primary action-hover px-20 fsc-10" @click="loadData">
            {{ dataLang["reg_contract_main_10"] }}
          </div>
          <div class="text-decoration-underline fsc-11 text-white" style="cursor: pointer" @click="resetFilter">
            Сбросить фильтр
          </div>

        </div>
      </div>
      <div class="position-relative h-100 container-fluid" style="min-height: 250px">
        <div class="d-flex gap-10 align-items-center mt-15">
          <div class="base-button base-button--action" @click="$modal.show('createOrderSupplyModal')">
            <img :src="require(`@/assets/icons/add.svg`)" width="13.5" height="13.5" />
            <span class="fsc-14">Добавить</span>
          </div>
          <!-- <div class="base-button base-button--action position-relative"
            @click="() => activeSelectRowsMultiple.length ? $modal.show('lastCancelSupplierModal') : $toast.error('Выберите хотя-бы одно поле')">
            <span class="fsc-14">Отменить</span>
          </div> -->
          <div class="base-button base-button--action position-relative"
            @click="() => activeSelectRowsMultiple.length ? $modal.show('deleteModal') : $toast.error('Выберите хотя-бы одно поле')">
            <img :src="require(`@/assets/icons/adddel.svg`)" width="13.5" height="13.5" />
            <span class="fsc-14">Удалить</span>
          </div>
        </div>
        <div v-show="!localLoading">
          <div class="d-flex justify-content-between align-items-center pb-15 pt-15">
            <div class="d-flex gap-15 align-items-center">
              <div class="btn btn-sm btn-thrity text-white fsc-14" @click="loadData">
                {{ dataLang['register_btn_filter_on'] }}
              </div>
              <div class="text-decoration-underline fsc-14 text-dark" style="cursor: pointer" @click="resetFilter">
                {{ dataLang['register_btn_filter_off'] }}
              </div>
            </div>
            <BasePagination :page-count="numPages" :pagination-params="paginationFinesStateParams"
              :showLimitInput="false" :page-range="10" :margin-pages="0" :break-view-class="''"
              :click-handler="loadData" :prev-text="''" :next-text="''" :container-class="'custom-pagination'"
              :page-class="'custom-pagination__item'" :pageLinkClass="'custom-pagination__item-link'">
            </BasePagination>
          </div>
          <div class="overflow-auto_" style="min-height: 400px">
            <ve-table class="fixed-header" style="width: 100%" :columns="columns" :table-data="dataTable" :border-x="true" :border-y="true"
              row-key-field-name="b2b_orders__id" ref="mainTable" :eventCustomOption="eventCustomOption"
              :cell-style-option="cellStyleOption" :checkbox-option="{
                selectedRowChange: selectedRowChange,
                selectedAllChange: selectedAllChange,
                hideSelectAll: false
              }" :clickHighlight="false" :rowStyleOption="{
                hoverHighlight: true
              }" :cellSelectionOption="{ enable: false }">
            </ve-table>
          </div>
        </div>
        <BaseLoader v-if="localLoading"></BaseLoader>
      </div>
    </div>

    <BaseModal name="deleteModal" width="420" height="320" :clickToClose="false" :shiftY="0.5" :adaptive="true"
      classes="bg-transparent shadow-none">
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn-close" @click="$modal.hide('deleteModal')"></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="text-center fw-semi-bold mb-15">
            Точно удалить?
          </p>

          <div class="d-flex justify-content-center mt-30 gap-15">

            <div class="base-button base-button--action fsc-14 px-15 text-uppercase" @click="
              $modal.hide('deleteModal')
              ">
              Отменить
            </div>
            <div class="btn btn-sm btn-primary action-hover fsc-14 px-15 text-uppercase" @click="onAcceptDelete">
              Подтверждаю
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
    <BaseModal name="lastCancelSupplierModal" width="420" height="320" :clickToClose="false" :shiftY="0.5"
      :adaptive="true" classes="bg-transparent shadow-none">
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn-close" @click="$modal.hide('lastCancelSupplierModal')"></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="text-center fw-semi-bold mb-15">
            Отмена заявки
          </p>
          <p class="text-center mb-0">
            Подтвердите отмену поставщиком <br />
            и перенос заявки в архив
          </p>

          <div class="d-flex justify-content-center mt-30 gap-15">

            <div class="base-button base-button--action fsc-14 px-15 text-uppercase" @click="
              $modal.hide('lastCancelSupplierModal')
              ">
              Отменить
            </div>
            <div class="btn btn-sm btn-primary action-hover fsc-14 px-15 text-uppercase" @click="onAcceptCancelModal">
              Подтверждаю
            </div>
          </div>
        </div>
      </div>
    </BaseModal>

    <BaseModal name="createOrderSupplyModal" @before-close="() => {
      selectsCreateModal = {
        b2b_orders__b2b_product_id: null,
        b2b_orders__buyer_company_id: null,
        b2b_orders__city_id: null
      }
    }" width="486" height="340" :clickToClose="false" :shiftY="0.5" :adaptive="true"
      classes="bg-transparent shadow-none overflow-visible">
      <div class="bg-white rounded-25 pt-20 pb-20 px-30 h-100">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn-close" @click="$modal.hide('createOrderSupplyModal')"></button>
        </div>
        <div class="d-flex h-100 flex-column justify-content-center pb-10">
          <p class="text-center fw-semi-bold mb-15">
            Создание новой заявки
          </p>
          <div class="wp-100 d-flex justify-content-between align-items-center mb-15">
            <div class="fsc-11">Город</div>

            <BaseSelect style="width: 300px" placeholder="" :showNoOptions="false" :showNoResults="false" selectLabel=""
              deselectLabel="" v-model="selectsCreateModal.b2b_orders__city_id" label="name"
              :options="selectsDataForCreateModal.b2b_orders__city_id" :maxHeight="200">
            </BaseSelect>
          </div>
          <div class="wp-100 d-flex justify-content-between align-items-center mb-15">
            <div class="fsc-11">Товар, услуга</div>

            <BaseSelect style="width: 300px" placeholder="" :showNoOptions="false" :showNoResults="false" selectLabel=""
              deselectLabel="" v-model="selectsCreateModal.b2b_orders__b2b_product_id" label="name"
              :options="selectsDataForCreateModal.b2b_orders__b2b_product_id" :maxHeight="200">
            </BaseSelect>
          </div>
          <div class="wp-100 d-flex justify-content-between align-items-center ">
            <div class="fsc-11">ID заказчика (ЛС)</div>

            <BaseSelect style="width: 300px" placeholder="" :showNoOptions="false" :showNoResults="false" selectLabel=""
              deselectLabel="" v-model="selectsCreateModal.b2b_orders__buyer_company_id" label="label"
              :options="selectsDataForCreateModal.b2b_orders__buyer_company_id" :maxHeight="200">
            </BaseSelect>
          </div>

          <div class="d-flex justify-content-center mt-30 gap-15">

            <div class="base-button base-button--action fsc-14 px-20 text-uppercase" @click="
              $modal.hide('createOrderSupplyModal')
              ">
              Отменить
            </div>
            <div class="btn btn-sm btn-primary action-hover fsc-14 px-20 text-uppercase" @click="onSaveModalCreate">
              Сохранить
            </div>
          </div>
        </div>
      </div>
    </BaseModal>

    


    
    <SuperSuppliersModal @updateDataTable="resetFilter" />
  </div>
</template>

<style lang="scss">
// if (
//           column.field === 'status'
//         ) {
//           if (
//             row.status === 'Новая'
//           ) {
//             return 'cell-status-suppliers-new'
//           }
//           else if (row.status === 'В работе') { return 'cell-status-suppliers-work'}
//           else if (row.status === 'Фин.контроль') { return 'cell-status-suppliers-control'}
//           else if (row.status === 'Период правок') { return 'cell-status-suppliers-edit'}


//         }
//       },
.cell-status-suppliers-new {
  background-color: #FF3A20 !important;
}

.cell-status-suppliers-work {
  background-color: #F5B704 !important;
}

.cell-status-suppliers-control {
  background-color: #44D2FF !important;
}

.cell-status-suppliers-edit {
  background-color: #23B14D !important;
}
</style>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { VeTable } from 'vue-easytable'
import GeneralService from '@/api/GeneralService'
import SuperSuppliersModal from "@/views/super-suppliers-modal/SuperSuppliersModal.vue";


export default {
  components: {
    VeTable,
    SuperSuppliersModal
  },

  data() {
    return {
      filterTimes: {
        ordersCreateStart: '',
        ordersCreateEnd: ''
      },
      searchInnString: '',
      searchInnState: null,
      newPromoString: '',
      errorAddPromoData: null,
      typePin: '',
      fullSum: 0,
      callbackForSum: () => { },
      summForPayment: 0,
      summForPaymentWithPercent: 0,
      foundsList: {},
      localLoading: true,
      statisticsFromMainRequest: {},
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      activateTab: '',
      updatedValues: {},
      computedAllPage: 1,
      currentPage: 1,
      intervalUpdate: null,
      haveNewOrder: false,
      activePagePagination: {},
      pincode: '',
      totalOnType: 0,
      dataForModal: {},
      aboutPageInfo: null,
      dataOfErrors: null,
      senderSmsPreset: null,
      peremText: '',
      typeOpenCancel: '',
      codeFromSms: '',
      selectsDataForCreateModal: {
        "b2b_orders__b2b_product_id": [],
        "b2b_orders__buyer_company_id": [],
        "b2b_orders__city_id": []
      },
      selectsCreateModal: {
        "b2b_orders__b2b_product_id": null,
        "b2b_orders__buyer_company_id": null,
        "b2b_orders__city_id": null
      },
      userPageSetting: {
        "sound": false,
        "sms": false,
        "email": false
      },
      selectsDataForModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        sms_presets: []
      },
      selectsFromModal: {
        owners: [],
        typeVehicles: [],
        objectsVehicle: [],
        sms_presets: []
      },
      selectsData: {
        b2b_orders__status_id: [],
        b2b_orders__b2b_product_id: [],
        b2b_orders__city_id: []
      },
      selectsFilter: {
        b2b_orders__status_id: [],
        b2b_orders__b2b_product_id: [],
        b2b_orders__city_id: []
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              console.log("CLICK EVENT FROM TABLE", row);
              this.$modal.show("superSuppliersModal", {
                b2b_orders__id: row.b2b_orders__id
              });
            },
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (
            column.field === 'status'
          ) {
            if (
              row.status === 'Новый'
            ) {
              return 'cell-status-suppliers-new'
            }
            else if (row.status === 'В работе') { return 'cell-status-suppliers-work' }
            else if (row.status === 'Фин.контроль') { return 'cell-status-suppliers-control' }
            else if (row.status === 'Период правок') { return 'cell-status-suppliers-edit' }
            else {
              return ''
            }


          }
        },
      },
    }
  },

  methods: {
    onSaveModalCreate() {
      if (
        this.selectsCreateModal.b2b_orders__b2b_product_id &&
        this.selectsCreateModal.b2b_orders__buyer_company_id &&
        this.selectsCreateModal.b2b_orders__city_id
      ) {
        GeneralService.editOrCreate(`/b2b-orders/type2`, {
          b2b_orders__b2b_product_id: this.selectsCreateModal.b2b_orders__b2b_product_id.id,
          b2b_orders__buyer_company_id: this.selectsCreateModal.b2b_orders__buyer_company_id.value,
          b2b_orders__city_id: this.selectsCreateModal.b2b_orders__city_id.id
        })
          .then((data) => {
            this.$toast.success(data.data.message)
          })
          .catch((e) => {
            if (e?.response) {
              this.$toast.error(e?.response.data.message, { duration: 5000 })
            }
          }).finally(() => {
            this.$modal.hide('createOrderSupplyModal')
            this.loadData()
          })
      }
    },
    onAcceptCancelModal() {
      GeneralService.edit(`/b2b-orders/${this.activeSelectRowsMultiple.at(-1)}`, { b2b_orders__status_id: 6 })
        .then((data) => {
          this.$toast.success(data.data.message)
        })
        .catch((e) => {
          if (e?.response) {
            this.$toast.error(e?.response.data.message, { duration: 5000 })
          }
        }).finally(() => {
          this.activeSelectRowsMultiple = []
          this.$modal.hide('lastCancelSupplierModal')
          this.loadData()
        })
    },
    updateUserSettingCheckboxValue(data) {
      GeneralService.edit(`/b2b-orders/employee/settings`, { [data.name]: data.value })
        .then((data) => {
          this.$toast.success(data.data.message)
        })
        .catch((e) => {
          this.$toast.error('Неизвестная ошибка при изменении настроек', { duration: 5000 })
        })
    },
    /// ОБРАБОТЧИК ПЕРЕХОДА ПО ВКЛАДКАМ
    async handleTabChange(newTab, oldTab) {
      if (newTab !== oldTab) {
        this.activateTab = newTab
        await this.resetFilter()
      }
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys
    },


    updateValue(data) {
      this.updatedValues[data.name] = data.value
    },



    onAcceptDelete() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.delete(
          `/b2b-orders/${this.activeSelectRowsMultiple}`
        )
          .then((data) => {
            this.$toast.success(data.data.message)
          })
          .catch((e) => {
            this.activeSelectRowsMultiple = []
            this.$toast.error(e.response.data.message, { duration: 5000 })
          })
          .finally(() => {
            this.$modal.hide('deleteModal')
            this.loadData()
          })
      }

    },

    computedTranslate(values, tranaslate) {
      let keys = Object.keys(values)
      let tranaslateLocal = tranaslate
      keys.forEach((keyName) => {
        tranaslateLocal = tranaslateLocal.replace(
          `\\${keyName}\\`,
          values[keyName]
        )
      })
      return tranaslateLocal
    },

    updateFilterItem(field, operator, value) {
      const idx = this.filter.findIndex(
        (x) => x.field === field && (operator ? x.operator === operator : true)
      )

      if (!value) {
        if (idx >= 0) this.filter.splice(idx, 1)
        return
      }

      const entry = { field, value, ...(operator && { operator }) }
      if (idx >= 0) {
        this.filter.splice(idx, 1, entry)
      } else {
        this.filter.push(entry)
      }
    },

    setCreatedAtFilter(direction, date) {
      const isoDate = date ? date.split('.').reverse().join('-') : ''
      if (direction === 'from') {
        this.updateFilterItem('b2b_orders__created_at', '>=', isoDate ? `${isoDate} 00:00:00` : '')
      } else if (direction === 'to') {
        this.updateFilterItem('b2b_orders__created_at', '<=', isoDate ? `${isoDate} 23:59:59` : '')
      }
    },



    resetFilter() {
      this.$refs.mainTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
      this.$refs.topFilter
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });

      this.filterTimes.ordersCreateStart = []
      this.filterTimes.ordersCreateEnd = []
      this.selectsFilter = {
        b2b_orders__status_id: [],
        b2b_orders__b2b_product_id: [],
        b2b_orders__city_id: []
      }
      this.filter = []
      this.loadData()
    },

    onCloseModal() {
      this.currentId = null
      this.activeSelectRowsMultiple = []
    },
    loadData(callback) {
      this.localLoading = true
      Promise.all([
        GeneralService.get(`/b2b-orders/employee/settings`)
          .then((data) => {
            this.userPageSetting = Object.assign(this.userPageSetting, data.data.data)
          })
          .catch((e) => {
            this.$toast.error('Неизвестная ошибка при загрузке настроек', { duration: 5000 })
          }),
        GeneralService.get(`/b2b-orders/select/cities`)
          .then((data) => {
            this.selectsDataForCreateModal.b2b_orders__city_id = data.data.data
          })
          .catch((e) => {
            this.$toast.error('Неизвестная ошибка при загрузке городов', { duration: 5000 })
          }),
        GeneralService.get(`/b2b-orders/select/companies`)
          .then((data) => {
            this.selectsDataForCreateModal.b2b_orders__buyer_company_id = data.data.data.map((val) => {
              return { label: Object.entries(val)[0][1], value: Object.entries(val)[0][0] }
            })
          })
          .catch((e) => {
            this.$toast.error('Неизвестная ошибка при загрузке компаний', { duration: 5000 })
          }),
        GeneralService.get(`/b2b-orders/select/products`)
          .then((data) => {
            this.selectsDataForCreateModal.b2b_orders__b2b_product_id = data.data.data
          })
          .catch((e) => {
            this.$toast.error('Неизвестная ошибка при загрузке продуктов', { duration: 5000 })
          })


        //     selectsDataForCreateModal: {
        //   "b2b_orders__b2b_product_id": [],
        //   "b2b_orders__buyer_company_id": [],
        //   "b2b_orders__city_id": []
        // },




        // 
        // /finreestr-funds?where=[{"field":"finreestr_funds__is_coming","value":1}]&fields=finreestr_funds__id,finreestr_funds__name,finreestr_funds__is_coming
      ]).then(() => {
        GeneralService.get(`/b2b-orders/table/${this.activateTab == 'Активные' ? 'active' : 'archive'}`, {
          params: {
            ...this.paginationFinesStateParams,
            where: JSON.stringify([
              ...this.filter
            ])
          }
        })
          .then((data) => {

            this.dataTable = data.data.data.rows
            this.haveNewOrder = data.data.is_sound
            this.selectsData = {
              b2b_orders__status_id: this.mapFiltersToOptions(data.data.filters.statuses),
              b2b_orders__b2b_product_id: this.mapFiltersToOptions(data.data.filters.products),
              b2b_orders__city_id: this.mapFiltersToOptions(data.data.filters.cities)
            }

            this.getFinesAll(data.data.data);
          })
          .catch((e) => {
            console.log(e);

            this.$toast.error('Неизвестная ошибка при загрузке таблицы', { duration: 5000 })
          })
        this.localLoading = false
      })
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == 'like' ? `;percent;${data.value};percent;` : data.value
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == 'like' && { operator: 'like' }),
          ...(data.operator && { operator: data.operator }),
          ...(data.mod && { mod: data.mod })
        })
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter
      }
    },

    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element['label'] = element[Object.keys(element).pop()]
          element['key'] = key
          element['value'] = Object.keys(element)[0]
          element['selectName'] = keyDataFromFetch
        })
      }
      return data
    },

    mapFiltersToOptions(raw) {
      if (!raw || typeof raw !== 'object') return []
      return Object.entries(raw).map(([value, label]) => ({ label, value }))
    },

    soundClick() {
      var audio = new Audio() // Создаём новый элемент Audio
      audio.src = this.userSetting.order_sound // Указываем путь к звуку "клика"
      audio.play() // Автоматически запускаем
    },

    ...mapActions('finesPagination', ['getFinesAll'])
  },
  mounted() {
    this.loadData()
    this.intervalUpdate = setInterval(async () => {
      await this.loadData()
      if (
        this.userPageSetting.sound &&
        this.haveNewOrder
      ) {
        this.soundClick()
        this.haveNewOrder = false
      }
    }, 60000)
  },
  beforeDestroy() { 
    clearInterval(this.intervalUpdate)
  },
  created() {
    this.activateTab = 'Активные'
  },
  computed: {
    ...mapState('translationModule', ['dataLang']),
    ...mapState('userSettingModule', ['userSetting']),
    ...mapState('finesPagination', ['paginationFinesStateParams']),
    ...mapGetters('finesPagination', ['numPages']),

    computedTabParams() {
      switch (this.activateTab) {
        case this.dataLang['register_object_owners_text_3']:
          return {
            url: 'fiz'
          }
        case this.dataLang['register_object_owners_text_4']:
          return {
            url: 'ip'
          }
        case this.dataLang['register_object_owners_text_5']:
          return {
            url: 'ur'
          }
      }
    },

    // columnsPromo


    columns() {
      return [
        {
          field: '',
          key: 'a62',
          type: 'checkbox',
          title: '',
          width: '1%',
          align: 'center'
        },
        {
          title: 'Заявка',
          children: [{
            field: 'b2b_orders__id',
            key: '1622336',
            title: '№',
            align: 'center',
            width: '4%',
            ellipsis: {
              showTitle: true,
              lineClamp: 1
            },
            renderHeaderCell: ({ column }, h) => {
              return (
                <div class={"h-100"}>
                  <div style={"height: 20px"}></div>
                  <div class={"text-center"}>{column.title}</div>

                  <BaseInputNew
                    placeholder=""
                    disabled={false}
                    onInput={this.fillFilter}
                    additionalParams={{ type: "like" }}
                    inputName={"b2b_orders__id"}
                    value={""}
                    nameSign={""}
                  />
                </div>
              );
            },
          },
          {
            field: 'b2b_orders__created_at',
            key: '5334543',
            title: 'Дата/ Время UTC',
            align: 'center',
            width: '8%',
            ellipsis: {
              showTitle: true,
              lineClamp: 1
            },
            renderHeaderCell: ({ column }, h) => {
              return (
                <div class={"h-100"}>
                  <div style={"height: 20px"}></div>
                  <div class={"text-center"}>{column.title}</div>
                  <div style={"height: 20px"}></div>
                </div>
              );
            },
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <span
                  title={
                    row.b2b_orders__created_at
                      ? this.$time(row.b2b_orders__created_at).format(
                        `${this.userSetting.company__tempalte_date} ${this.userSetting.company__tempalte_time}`
                      )
                      : ""
                  }
                >
                  {row.b2b_orders__created_at
                    ? this.$time(row.b2b_orders__created_at).format(
                      `${this.userSetting.company__tempalte_date} ${this.userSetting.company__tempalte_time}`
                    )
                    : ""}
                </span>
              );
            }
          },
          {
            field: 'cities__name',
            key: '6234331',
            title: 'Город',
            align: 'center',
            width: '6%',
            ellipsis: {
              showTitle: true,
              lineClamp: 1
            },
            renderHeaderCell: ({ column }, h) => {
              return (
                <div>
                  <div style={"height: 20px"}></div>
                  <div class={"text-center"}>{column.title}</div>

                  <BaseSelect
                    vModel={this.selectsFilter.b2b_orders__city_id}
                    onInput={(e, w) => {
                      if (
                        !this.filter.find((x) => x.field == "b2b_orders__city_id")
                      ) {
                        this.filter.push({
                          field: "b2b_orders__city_id",
                          value: e.value,
                        });
                      } else {
                        this.filter[
                          this.filter.findIndex(
                            (x) => x.field == "b2b_orders__city_id"
                          )
                        ].value = e.value;
                      }
                    }}
                    style={"width: 100%"}
                    label={"label"}
                    placeholder={""}
                    id={"id"}
                    selectLabel={""}
                    deselectLabel={""}
                    options={this.selectsData.b2b_orders__city_id}
                  ></BaseSelect>
                </div>
              );
            },
          },
          {
            field: 'product_name',
            key: '125441',
            title: 'Продукт/ услуга',
            align: 'center',
            width: '10%',
            ellipsis: {
              showTitle: true,
              lineClamp: 1
            },
            renderHeaderCell: ({ column }, h) => {
              return (
                <div class={"h-100"}>
                  <div style={"height: 20px"}></div>
                  <div class={"text-center"}>{column.title}</div>
                  <div style={"height: 20px"}></div>
                </div>
              );
            },
            renderHeaderCell: ({ column }, h) => {
              return (
                <div>
                  <div style={"height: 20px"}></div>
                  <div class={"text-center"}>{column.title}</div>

                  <BaseSelect
                    vModel={this.selectsFilter.b2b_orders__b2b_product_id}
                    onInput={(e, w) => {
                      if (
                        !this.filter.find((x) => x.field == "b2b_orders__b2b_product_id")
                      ) {
                        this.filter.push({
                          field: "b2b_orders__b2b_product_id",
                          value: e.value,
                        });
                      } else {
                        this.filter[
                          this.filter.findIndex(
                            (x) => x.field == "b2b_orders__b2b_product_id"
                          )
                        ].value = e.value;
                      }
                    }}
                    style={"width: 100%"}
                    label={"label"}
                    placeholder={""}
                    id={"id"}
                    selectLabel={""}
                    deselectLabel={""}
                    options={this.selectsData.b2b_orders__b2b_product_id}
                  ></BaseSelect>
                </div>
              );
            },
          },
          {
            field: 'b2b_orders__finance_proceeds',
            key: '13661',
            title: 'Сумма',
            align: 'center',
            width: '5%',
            ellipsis: {
              showTitle: true,
              lineClamp: 1
            },
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <span
                >
                  {row.b2b_orders__finance_proceeds
                    ? row.b2b_orders__finance_proceeds.replace('.', ',')
                    : ""}
                </span>
              );
            }
          },
          {
            field: 'b2b_orders__supplier_amount',
            key: '1334441',
            title: 'Комиссия Сириус',
            align: 'center',
            width: '5%',
            ellipsis: {
              showTitle: true,
              lineClamp: 1
            },
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <span
                >
                  {row.b2b_orders__supplier_amount
                    ? row.b2b_orders__supplier_amount.replace('.', ',')
                    : ""}
                </span>
              );
            },
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <span
                  title={
                    row.companies__created_at
                      ? this.$time(row.companies__created_at).format(
                        `${this.userSetting.company__tempalte_date}`
                      )
                      : ""
                  }
                >
                  {row.companies__created_at
                    ? this.$time(row.companies__created_at).format(
                      `${this.userSetting.company__tempalte_date}`
                    )
                    : ""}
                </span>
              );
            }
          },]
        },

        {
          title: 'Покупатель',
          children: [
            {
              field: 'b2b_orders__buyer_company_id',
              key: '456845',
              title: 'ID',
              align: 'center',
              width: '4%',
              ellipsis: {
                showTitle: true,
                lineClamp: 1
              },
              renderHeaderCell: ({ column }, h) => {
                return (
                  <div class={"h-100"}>
                    <div style={"height: 20px"}></div>
                    <div class={"text-center"}>{column.title}</div>

                    <BaseInputNew
                      placeholder=""
                      disabled={false}
                      onInput={this.fillFilter}
                      additionalParams={{}}
                      inputName={"b2b_orders__buyer_company_id"}
                      value={""}
                      nameSign={""}
                    />
                  </div>
                );
              },
            },
            {
              field: 'employees__name',
              key: '99943',
              title: 'ФИО',
              align: 'center',
              width: '15%',
              ellipsis: {
                showTitle: true,
                lineClamp: 1
              }
            },
            {
              field: 'employees__phone',
              key: '868686',
              title: 'Телефон',
              align: 'center',
              width: '8%',
              ellipsis: {
                showTitle: true,
                lineClamp: 1
              }
            },

          ]
        },
        {
          field: 'referal_promocodes__code',
          key: '986724',
          title: 'ID пост',
          align: 'center',
          width: '6%',
          ellipsis: {
            showTitle: true,
            lineClamp: 1
          }
        },
        {
          field: 'comment',
          key: '534534543',
          title: 'Последний комментарий',
          align: 'center',
          width: '12%',
          ellipsis: {
            showTitle: true,
            lineClamp: 1
          }
        },
        {
          field: 'status',
          key: '62341',
          title: 'Статус',
          align: 'center',
          width: '10%',
          ellipsis: {
            showTitle: true,
            lineClamp: 1
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div style={"height: 20px"}></div>
                <div class={"text-center"}>{column.title}</div>

                <BaseSelect
                  vModel={this.selectsFilter.b2b_orders__status_id}
                  onInput={(e, w) => {
                    if (
                      !this.filter.find((x) => x.field == "b2b_orders__status_id")
                    ) {
                      this.filter.push({
                        field: "b2b_orders__status_id",
                        value: e.value,
                      });
                    } else {
                      this.filter[
                        this.filter.findIndex(
                          (x) => x.field == "b2b_orders__status_id"
                        )
                      ].value = e.value;
                    }
                  }}
                  style={"width: 100%"}
                  label={"label"}
                  placeholder={""}
                  id={"id"}
                  selectLabel={""}
                  deselectLabel={""}
                  options={this.selectsData.b2b_orders__status_id}
                ></BaseSelect>
              </div>
            );
          },
        },

      ]
    }
  }
}
</script>
